import { AlertTriangle, CheckCircle2, Clock } from 'lucide-react';
import { Badge } from '../ui/badge';
import { planName } from '../../lib/support';
import { planState } from '../../lib/planState';

// Told apart by icon and words as well as fill (DESIGN.md)
const LOOK = {
  paid: { className: 'bg-moss-soft text-moss', icon: CheckCircle2 },
  ending: { className: 'bg-ochre-soft text-ochre', icon: Clock, label: 'Ending' },
  trial: { className: 'bg-ochre-soft text-ochre', icon: Clock, label: 'Trial' },
  expired: { className: 'bg-brick-soft text-brick', icon: AlertTriangle, label: 'Expired' },
  canceled: { className: 'bg-mist text-muted-foreground', label: 'Canceled' },
  none: { className: 'bg-transparent border-line-strong text-muted-foreground', label: 'None' },
};

export function PlanBadge({ user }) {
  const state = planState(user);
  const { className, icon: Icon, label } = LOOK[state];
  return (
    <Badge variant="outline" className={`border-transparent whitespace-nowrap ${className}`}>
      {Icon && <Icon className="w-3 h-3 mr-1" />}
      {label || planName(user.subscription_plan)}
    </Badge>
  );
}
